import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { GetAssessmentMAndESelfForm } from '../../redux/actions/assessment'
import MAndESelfFormWidget from '../../widgets/assessment/MAndESelfFormWidget'
import { isEmpty } from 'lodash-es'

export default function MAndESelfForm() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionStorage.getItem('project_code')
  const id = sessionStorage.getItem('m_e_s_id')

  const params = new URLSearchParams(window.location.search)
  const assessmentId = params.get('assId')
  const preview = params.get('preview')

  useEffect(() => {
    if (preview) {
      if (assessmentId) {
        handleGetSchema('PREVIEW', '', assessmentId)
      } else {
        setError({
          statusCode: 404,
          errorMessage: 'ไม่พบ รหัสแบบประเมินที่ต้องการดูตัวอย่าง',
        })
      }
    } else {
      if (projectCode) {
        handleGetSchema(projectCode, id, '')
      } else {
        setError({
          statusCode: 404,
          errorMessage: 'ไม่พบ รหัสโครงการ กรุณาเลือกโครงการก่อน',
        })
      }
    }
  }, [projectCode])

  const handleGetSchema = async (projectCode, id, assessmentId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await GetAssessmentMAndESelfForm(projectCode, id, assessmentId)
      setSchema(response)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi isShowGoButton />
      {schema.forms?.assessmentForm && (
        <MAndESelfFormWidget schema={schema.forms.assessmentForm} preView={preview} />
      )}
    </SidebarProposal>
  )
}
